module.exports = __webpack_public_path__ + "iconOne.9118d9cd7b3d81d7cf71.png";


//////////////////
// WEBPACK FOOTER
// C:/Users/Artem/Desktop/Programming/studio/creativeDigital/src/assets/decorativeElements/iconOne.png
// module id = ../../../../../src/assets/decorativeElements/iconOne.png
// module chunks = 0